import { combineReducers } from 'redux';
import services, { InitialServicesReducer } from './services.reducer';
import templates, {
	InitialTemplatesReducer as TemplatesReducer,
} from './templates.reducer';
import surveys, { InitialSurveysReducer } from './surveys.reducer';

export const InitialTemplatesReducer = {
	services: InitialServicesReducer,
	templates: TemplatesReducer,
	surveys: InitialSurveysReducer,
};

export default combineReducers({
	services,
	templates,
	surveys,
});
